import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P80-E1",
    audio: "img/FriendsPlus/Page80/Audio/audio-e1-p80.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page80/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page80/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/tieude-e1-p80.mp3",
        },
        { url: "img/FriendsPlus/Page80/E1/3.jpg" },
      ],
      [
        // Column2
        {
          url: "img/FriendsPlus/Page80/E1/4.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/good.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/bad.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/wet.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/dry.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/photo.mp3",
        },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P80-E2",
    audio: "img/FriendsPlus/Page80/Audio/audio-e2-p80.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page80/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page80/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/tieude-e2-p80.mp3",
        },
        { url: "img/FriendsPlus/Page80/E2/3.jpg" },
      ],
      [
        // Column2
        {
          url: "img/FriendsPlus/Page80/E2/4.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/good.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E2/5.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/bad.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/wet.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/dry.mp3",
        },
        {
          url: "img/FriendsPlus/Page80/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page80/Audio/photo.mp3",
        },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P80-E3",
    audio: "img/FriendsPlus/Page80/Audio/audio-e3-p80.mp3",
    video: "Videos/e3.p80.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page80/E3/1.jpg" },
        { url: "img/FriendsPlus/Page80/E3/2.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/tieude-e3-p80.mp3", },
        { url: "img/FriendsPlus/Page80/E3/3.jpg" },
      ],
      [
        { url: "img/FriendsPlus/Page80/E3/4.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh1-e3-p80.mp3" },
        { url: "img/FriendsPlus/Page80/E3/5.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh2-e3-p80.mp3" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page80/E3/6.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh3-e3-p80.mp3" },
        { url: "img/FriendsPlus/Page80/E3/7.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh4-e3-p80.mp3" },
      ],
      [
        { url: "img/FriendsPlus/Page80/E3/8.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh5-e3-p80.mp3" },
        { url: "img/FriendsPlus/Page80/E3/9.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh6-e3-p80.mp3" },
      ],
    ],
  },
};

export default json;
